
let ENV = 'UAT'; // LOCAL, DEV, QA, LIVE, UAT

let config = {};

if (ENV === 'LOCAL') {
    config.API_URL = "http://localhost:5000/api";
    config.APP_NAME = "AssessPro";
    config.APP_VERSION = "1.0.0";
    config.ENVIRONMENT = "LOCAL";
    config.BASE_URL = "http://localhost:3000";
} else if (ENV === 'UAT') {
    config.API_URL = "https://uat-backend-asses.qrsolutions.in/api";
    config.APP_NAME = "AssessPro";
    config.APP_VERSION = "1.0.0";
    config.ENVIRONMENT = "DEV";
    config.BASE_URL = "https://uat.asses.qrsolutions.in/";
} 

export default config;